import { createContext, useContext, useRef, useState } from 'react'

import { useDisclosure } from '@mantine/hooks'

const CallDrawerContext = createContext(null)

const CallDrawerContextProvider = ({ children }) => {
  const [opened, { open, close }] = useDisclosure(false)
  const [activityLogId, setActivityLogId] = useState(null)
  const onCloseCallbackRef = useRef<(() => void) | null>(null)

  const handleOpen = (activityLogId, onCloseCallback?: () => void) => {
    setActivityLogId(activityLogId)
    onCloseCallbackRef.current = onCloseCallback ?? null
    open()
  }

  const handleClose = () => {
    close()
    if (onCloseCallbackRef.current) {
      onCloseCallbackRef.current()
      onCloseCallbackRef.current = null
    }
  }

  return (
    <CallDrawerContext.Provider
      value={{
        opened,
        close: handleClose,
        handleOpen,
        activityLogId,
      }}
    >
      {children}
    </CallDrawerContext.Provider>
  )
}

export function useCallDrawerContext() {
  return useContext(CallDrawerContext)
}

export { CallDrawerContext, CallDrawerContextProvider }
